export enum CITypes {
  CI10 = 1,
  CI20 = 2,
}

export const PeriodIndexTypes: any = {
  "1d": 0,
  "1w": 1,
  "1m": 2,
  "3m": 3,
  "6m": 4,
  "1y": 5,
  all: 6,
};

export const PeriodTypesArray: string[] = [
  "1d",
  "1w",
  "1m",
  "3m",
  "6m",
  "1y",
  "all",
];

export enum CorrelationBases {
  Daily = 1,
  Monthly = 2,
  Annual = 3
};

export enum RollingCorrelationPeriods {
  _20TradingDays = 20,
  _30TradingDays = 30,
  _40TradingDays = 40,
  _50TradingDays = 50,
  _60TradingDays = 60,
  _70TradingDays = 70,
  _80TradingDays = 80,
  _90TradingDays = 90,
  _100TradingDays = 100,
  _110TradingDays = 110,
  _120TradingDays = 120,
};

export const RollingCorrelationPeriodsArray: any[] = [
  {
    title: "20 Trading Days",
    value: 20,
  },
  {
    title: "30 Trading Days",
    value: 30,
  },
  {
    title: "40 Trading Days",
    value: 40,
  },
  {
    title: "50 Trading Days",
    value: 50,
  },
  {
    title: "60 Trading Days",
    value: 60,
  },
  {
    title: "70 Trading Days",
    value: 70,
  },
  {
    title: "80 Trading Days",
    value: 80,
  },
  {
    title: "90 Trading Days",
    value: 90,
  },
  {
    title: "100 Trading Days",
    value: 100,
  },
  {
    title: "110 Trading Days",
    value: 110,
  },
  {
    title: "120 Trading Days",
    value: 120
  }
];

export enum RecordState {
  Pending = 0,
  Active = 2,
  Locked = 4,
  Archived = 6,
  Deleted = 10,
}

export const GetRecordState = (state: RecordState): string => {
  switch (state) {
    case RecordState.Pending:
      return 'Pending';

    case RecordState.Locked:
      return 'Locked';

    case RecordState.Archived:
      return 'Archived';

    case RecordState.Deleted:
      return 'Deleted';

    default:
      return 'Active';
  };
}

export enum MagicPagesTypes {
  Home = 1,
  Contacts = 2,
  Copyright = 3,
  Terms = 4,
  Ci50 = 5,
  PrivacyPolicy = 6,
  CryptoMarkets = 7,
  Blog = 8,
  Login = 9,
  Register = 10,
  RestorePassword = 11,
  Widgets = 12,
  Advertising = 13,
  Methodology = 14,
  Press = 15,
  Api = 16,
  Education = 17,
  ChangeLogs = 18,
  News = 19,
  FearAndGreedIndex = 20,
  NotInUse1 = 21,
  NotInUse2 = 22,
  Resources = 23,
}

export enum UserRoleTypes {
  Admin = 1,
  User = 2,
}

export enum SettingsTypes {
  CopyrightInfo = 1,
  LogoPath = 2,
  ContactMapFrame = 3,
  ContactMapFrame1 = 4,
  AdBlock1 = 5,
  AdBlock2 = 6,
  EmailLayout = 8,
}

export enum LogLevelsTypes {
  Trace = 0,

  Debug = 1,

  Information = 2,

  Warning = 3,
  Error = 4,

  None = 5,
}

export enum EngineModalMode {
  Prices = 1,
  CI = 2,
  CIVolotility = 3,
  InstrumentVolotility = 4,
  MissingPrices = 5,
  MissingGlobalHistory = 6,
}
